import React from "react";
import { achievements } from "../SampleData";
import SvgMapper from "../../features/common/SvgMapper";

const Achievements = () => {
  
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Achievements</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {achievements.map((item, index) => (
          <div
            key={index}
            className={`flex items-center space-x-3 p-4 bg-${item.color}-50 rounded-lg`}
          >
            <div className={`p-2 bg-${item.color}-100 rounded-lg`}>
              {SvgMapper[item.icon] && SvgMapper[item.icon]("w-6 h-6 text-" + item.color + "-600")}
            </div>
            <div>
              <p className={`font-medium text-${item.color}-900`}>
                {item.title}
              </p>
              <p className={`text-sm text-${item.color}-700`}>
                {item.subtitle}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Achievements;
